import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TicketService } from '@app/core/services/ticket.service';
import { Ticket } from '@app/shared/models/ticket.model';

@Component({
    selector: 'app-admin-ticket',
    templateUrl: './admin-ticket.component.html',
    styleUrls: ['./admin-ticket.component.scss']
})
export class AdminTicketComponent implements OnInit {
    ticketId: number;
    loading = false;
    hasTasks = false;

    tabs: any[] = []

    constructor(private route: ActivatedRoute, private ticketService: TicketService) {
    }

    ngOnInit() {
        this.loading = true;
        this.route.params.subscribe(
            (params) => {
                this.ticketId = +params['id'];
                this.getTicketHasTasks(this.ticketId);
            }
        );
    }

    getTicketHasTasks(ticketId: number) {
        this.ticketService.getTicketHasTasks(ticketId).subscribe(
            (data: boolean) => {
                this.hasTasks = data;
                this.loading = false;
                this.tabs = this.computeTabs();
            },
            (error) => {
                this.loading = false;
            }
        );
    }

    computeTabs() {
        return this.hasTasks ? [
                {
                    link: 'details',
                    label: 'service.tickets.details.tabs.details'
                },
                {
                    link: 'tasks',
                    label: 'service.tickets.details.tabs.tasks'
                },
            ] :
            [
                {
                    link: 'details',
                    label: 'service.tickets.details.tabs.details'
                },
            ];
    }

}
